import { render, staticRenderFns } from "./VotingIdeasContent.vue?vue&type=template&id=b12b22aa&scoped=true&"
import script from "./VotingIdeasContent.vue?vue&type=script&lang=js&"
export * from "./VotingIdeasContent.vue?vue&type=script&lang=js&"
import style0 from "./VotingIdeasContent.vue?vue&type=style&index=0&id=b12b22aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12b22aa",
  null
  
)

export default component.exports